import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { ChapterFormValues } from "src/models/Chapter.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<ChapterFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any 
  editorValue?: string;
};

const ChapterForm = ({ formikProps, onClose, formType , setSaveNextChecked ,  saveNextChecked ,editorValue =''   }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex p-4 flex-col gap-6 relative">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">{formType} Chapter</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Chapter Name */}
        <div>
          <ATMTextField 
          required
            name="chapterName"
            value={values.chapterName}
            onChange={(e) => setFieldValue("chapterName", e.target.value)}
            label="Chapter Name"
            placeholder="Enter Chapter Name"
            onBlur={handleBlur}
          />
        </div>
        {/* Chapter Content */}
        <div className="">
      
          <ATMHTMLEditor
            key={editorValue}
            label="Description"
            required
            value={values?.chapterContent}
            placeholder="Write description here...."
            onChange={(newValue: any) => {
              setFieldValue("chapterContent", newValue);
            }}
          />
          {/* <ATMTextArea 
          minRows={3}
            name="chapterContent"
            value={values.chapterContent}
            onChange={(newValue) => setFieldValue("chapterContent", newValue)}
            label="Chapter Content (HTML_EDITOR)"
            placeholder="Enter Chapter Content"
            onBlur={handleBlur}
          /> */}
        </div>
        {/* Duration */}
        <div className="">
          <ATMTextField 
            required
            name="duration"
            value={values?.duration}
            onChange={(e) =>
              handleValidNumber(e) && setFieldValue("duration", e.target.value)
            }
            label="Duration (In Minutes)"
            placeholder="Enter Duration"
            onBlur={handleBlur}
          />
        </div>

      </div>
      {formType === "Add" && (
        <div>
          <ATMCheckbox
            label="Save and Next"
            checked={saveNextChecked}
            onChange={(checked) => {
              setSaveNextChecked(checked);
            }}
          />
        </div>
      )}
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ChapterForm;
